module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-14-c2f1fc07abeb98d167e1d1d068c787fd.jpeg";